import React from 'react'
import Images from '/data/images'
import cx from 'classnames'

class Image extends React.Component {
  state = {
    imageStatus: 'loading'
  }

  handleImageLoaded() {
    this.setState({ imageStatus: 'loaded' })
  }

  generateImageWrapperClasses() {
    const { images } = this.props

    return cx('overflow-hidden', {
      relative: images.overlayText,
      'rounded-tr rounded-bl': !images.notRounded,
      'rounded-none': images.notRounded
    })
  }

  generateImageClasses() {
    const { images, type, highlight, sdg } = this.props

    return cx('block mx-auto', {
      'mb-15': type === 'quote',
      'min-h-117': !highlight && !images.widthAuto && !sdg,
      'w-full': !images.widthAuto && !sdg,
      'w-100': sdg,
    })
  }

  renderOverlayText() {
    const { overlayText } = this.props.images

    if (!overlayText) {
      return null
    }

    return (
      <div className="font-condensed text-24 text-white uppercase absolute inset-0 p-30 flex justify-center items-center text-center">
        <h3 data-label="image-overlay-text" className="">
          {overlayText}
        </h3>
      </div>
    )
  }

  render() {
    const { images } = this.props

    if (!images) {
      return null
    }

    return (
      <div className={this.generateImageWrapperClasses()}>
        <img
          data-label="image"
          alt={images.description ? images.description : ''}
          className={this.generateImageClasses()}
          src={Images[images.key].defaultRes}
          srcSet={`${Images[images.key].defaultRes} 1x, ${Images[images.key].hiRes} 2x`}
          onLoad={() => this.handleImageLoaded()}
          data-status={this.state.imageStatus}
        />

        {this.renderOverlayText()}
      </div>
    )
  }
}

export default Image
